var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticStyle:{"border-bottom":"1px solid #dfdfdf"},attrs:{"no-gutters":""}},[_c('v-col',{staticStyle:{"border-right":"1px solid #dfdfdf"},attrs:{"cols":_vm.$vuetify.breakpoint.mdAndUp ? '6' : '12'}},[_c('Position')],1),_c('v-col',{attrs:{"cols":_vm.$vuetify.breakpoint.mdAndUp ? '6' : '12'}},[_c('Information')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }